import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/risk360/factors/{-$id}')({
  beforeLoad: () => getTitleContextSlice('Factors'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
